var _defs, _clipPath, _defs2, _clipPath2, _path, _defs3, _clipPath3, _defs4, _clipPath4, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _defs5, _clipPath5, _defs6, _clipPath6, _rect, _defs7, _clipPath7, _defs8, _clipPath8, _rect2, _path8, _path9, _path10, _defs9, _clipPath9, _rect3, _defs10, _clipPath10, _rect4, _defs11, _clipPath11, _rect5, _defs12, _clipPath12, _rect6, _g, _g2, _defs13, _clipPath13, _rect7, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.18,
    y: 0.33,
    width: 150,
    height: 150
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000053539157196768717060000007717655342612454556_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38473",
    clipPath: "url(#SVGID_00000053539157196768717060000007717655342612454556_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38456"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000084511797113690512120000012192580756617343879_",
    x: 0.18,
    y: 0.33,
    width: 150,
    height: 150
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070811127564361316970000013766159224516563646_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000084511797113690512120000012192580756617343879_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38455",
    clipPath: "url(#SVGID_00000070811127564361316970000013766159224516563646_)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_64820",
    fill: "#F8B4B6",
    d: "M75.18,0.33c41.42,0,75,33.58,75,75s-33.58,75-75,75s-75-33.58-75-75 S33.76,0.33,75.18,0.33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38444",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38443"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000166662636189987840260000008423054521516772738_",
    x: 0.18,
    y: 0.33,
    width: 150,
    height: 150
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101088978530730924020000006226400434221237382_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166662636189987840260000008423054521516772738_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38442",
    clipPath: "url(#SVGID_00000101088978530730924020000006226400434221237382_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38441"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000151506711467203691400000015586787219988556200_",
    d: "M75.18,0.33c41.42,0,75,33.58,75,75 s-33.58,75-75,75s-75-33.58-75-75S33.76,0.33,75.18,0.33"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144337189316072200070000004115896606195646082_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000151506711467203691400000015586787219988556200_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38440",
    clipPath: "url(#SVGID_00000144337189316072200070000004115896606195646082_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_19587_00000112605195052355522990000008605661515721032099_",
    gradientUnits: "userSpaceOnUse",
    x1: -1761.8451,
    y1: 5.294,
    x2: -1761.7911,
    y2: 6.25,
    gradientTransform: "matrix(176.1287 -43.1706 43.1706 176.1287 310131.9062 -77002.6875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F69D9F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    style: {
      stopColor: "#F15C5E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05354"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle_19587",
    fill: "url(#Rectangle_19587_00000112605195052355522990000008605661515721032099_)",
    points: " -34.49,8.83 141.64,-34.34 184.81,141.79 8.68,184.96  "
  }))))))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64822",
    fill: "#F05354",
    d: "M40.18,31.53c0-3.59-2.91-6.5-6.5-6.5s-6.5,2.91-6.5,6.5c-0.01,2.67,1.56,5.1,4,6.2 v80.3h5v-80.4C38.61,36.58,40.19,34.18,40.18,31.53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64823",
    fill: "#FFFFFF",
    d: "M33.68,27.33c2.21,0,4,1.79,4,4s-1.79,4-4,4s-4-1.79-4-4S31.47,27.33,33.68,27.33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64824",
    fill: "#F05354",
    d: "M123.18,31.53c0-3.59-2.91-6.5-6.5-6.5s-6.5,2.91-6.5,6.5c-0.01,2.67,1.56,5.1,4,6.2 v80.3h5v-80.4C121.61,36.58,123.19,34.18,123.18,31.53"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64825",
    fill: "#FFFFFF",
    d: "M116.68,27.33c2.21,0,4,1.79,4,4s-1.79,4-4,4s-4-1.79-4-4S114.47,27.33,116.68,27.33 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64826",
    fill: "#FFFFFF",
    d: "M127.18,66.33h-104c-1.1,0-2-0.9-2-2v-20c0-1.1,0.9-2,2-2h104c1.1,0,2,0.9,2,2v20 C129.18,65.44,128.28,66.33,127.18,66.33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64827",
    fill: "#FFFFFF",
    d: "M127.18,101.33h-104c-1.1,0-2-0.9-2-2v-20c0-1.1,0.9-2,2-2h104c1.1,0,2,0.9,2,2v20 C129.18,100.44,128.28,101.33,127.18,101.33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38449",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38448"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000124846655272725528930000009819681081972779168_",
    x: 21.18,
    y: 42.33,
    width: 108,
    height: 24
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000059309209414150251380000013165281296688155526_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000124846655272725528930000009819681081972779168_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38447",
    clipPath: "url(#SVGID_00000059309209414150251380000013165281296688155526_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38446"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000062193977535667230420000012596066657053521025_",
    d: "M127.18,66.33h-104c-1.1,0-2-0.9-2-2v-20 c0-1.1,0.9-2,2-2h104c1.1,0,2,0.9,2,2v20C129.18,65.44,128.28,66.33,127.18,66.33"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000111151907975033582100000015254696534837650335_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000062193977535667230420000012596066657053521025_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38445",
    clipPath: "url(#SVGID_00000111151907975033582100000015254696534837650335_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_19589_00000077323507779639356820000014513010896563579795_",
    gradientUnits: "userSpaceOnUse",
    x1: -1756.8127,
    y1: 29.0804,
    x2: -1756.8038,
    y2: 29.0804,
    gradientTransform: "matrix(108 0 0 24 189736 -643.5996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    style: {
      stopColor: "#FFFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    style: {
      stopColor: "#FEF1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    style: {
      stopColor: "#FCDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    style: {
      stopColor: "#FAC5C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8B4B6"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19589",
    x: 21.18,
    y: 42.33,
    fill: "url(#Rectangle_19589_00000077323507779639356820000014513010896563579795_)",
    width: 108,
    height: 24
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38454",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38453"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000170968255156899711100000007668097644518728332_",
    x: 21.18,
    y: 77.33,
    width: 108,
    height: 24
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174602864874329621110000008441200941380824976_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170968255156899711100000007668097644518728332_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38452",
    clipPath: "url(#SVGID_00000174602864874329621110000008441200941380824976_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38451"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000173127140182169678640000000718363993161227957_",
    d: "M127.18,101.33h-104c-1.1,0-2-0.9-2-2v-20 c0-1.1,0.9-2,2-2h104c1.1,0,2,0.9,2,2v20C129.18,100.44,128.28,101.33,127.18,101.33"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024723881997230239560000005357367053533689245_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000173127140182169678640000000718363993161227957_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38450",
    clipPath: "url(#SVGID_00000024723881997230239560000005357367053533689245_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_19591_00000016779504828488513900000008669718690830597278_",
    gradientUnits: "userSpaceOnUse",
    x1: -1756.8127,
    y1: 29.0804,
    x2: -1756.8038,
    y2: 29.0804,
    gradientTransform: "matrix(108 0 0 24 189736 -608.5996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259,
    style: {
      stopColor: "#FFFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    style: {
      stopColor: "#FEF1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    style: {
      stopColor: "#FCDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894,
    style: {
      stopColor: "#FAC5C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8B4B6"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19591",
    x: 21.18,
    y: 77.33,
    fill: "url(#Rectangle_19591_00000016779504828488513900000008669718690830597278_)",
    width: 108,
    height: 24
  }))))))))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64830",
    fill: "#F05354",
    d: "M94.18,77.33h-21.8l-24,24h21.8L94.18,77.33z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64831",
    fill: "#F05354",
    d: "M33.08,77.33l-11.9,11.9v10.1c0,1.1,0.9,2,2,2h7.7l24-24H33.08z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_64832",
    fill: "#F05354",
    d: "M129.18,81.63v-2.3c0-1.1-0.9-2-2-2h-15.6l-24,24h21.8L129.18,81.63z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38458"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170276727886769225750000005626572319505646980_",
    d: "M28.78,42.33l-7.6,7.6v14.4c0,1.1,0.9,2,2,2h3.5 l24-24H28.78z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114774267728445256910000014739744602986572473_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170276727886769225750000005626572319505646980_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38457",
    clipPath: "url(#SVGID_00000114774267728445256910000014739744602986572473_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_19594_00000039849832263431890210000006492375223524757943_",
    gradientUnits: "userSpaceOnUse",
    x1: -1727.0452,
    y1: 29.0804,
    x2: -1727.0112,
    y2: 29.0804,
    gradientTransform: "matrix(29.5 0 0 24 50948.0078 -643.5996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05253"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C52126"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19594",
    x: 21.18,
    y: 42.33,
    fill: "url(#Rectangle_19594_00000039849832263431890210000006492375223524757943_)",
    width: 29.5,
    height: 24
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38460"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000168796018474163480010000006285667369240094132_",
    points: "68.08,42.33 44.08,66.33 65.88,66.33  89.88,42.33  "
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118395587949275543010000009021154556172504462_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168796018474163480010000006285667369240094132_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38459",
    clipPath: "url(#SVGID_00000118395587949275543010000009021154556172504462_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_19595_00000114045785176134820040000007888739359654585492_",
    gradientUnits: "userSpaceOnUse",
    x1: -1742.1212,
    y1: 29.0804,
    x2: -1742.0992,
    y2: 29.0804,
    gradientTransform: "matrix(45.8 0 0 24 79789.3125 -643.5996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05253"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C52126"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19595",
    x: 44.08,
    y: 42.33,
    fill: "url(#Rectangle_19595_00000114045785176134820040000007888739359654585492_)",
    width: 45.8,
    height: 24
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38462"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000019677971706016040190000007763681441246908324_",
    d: "M107.28,42.33l-24,24h21.9l23.4-23.4 c-0.37-0.38-0.87-0.6-1.4-0.6H107.28z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045603400498186995870000001866911993460376760_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019677971706016040190000007763681441246908324_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38461",
    clipPath: "url(#SVGID_00000045603400498186995870000001866911993460376760_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_19596_00000170257442874937938000000006202379416903269516_",
    gradientUnits: "userSpaceOnUse",
    x1: -1742.7,
    y1: 29.0804,
    x2: -1742.678,
    y2: 29.0804,
    gradientTransform: "matrix(45.3 0 0 24 78944.5078 -643.5996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05253"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C52126"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19596",
    x: 83.28,
    y: 42.33,
    fill: "url(#Rectangle_19596_00000170257442874937938000000006202379416903269516_)",
    width: 45.3,
    height: 24
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38464"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000136386398833756109030000014540239021003682462_",
    d: "M122.58,66.33h4.6c1.1,0,2-0.9,2-2v-4.6 L122.58,66.33z"
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064344775233713215970000007832584080521910406_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000136386398833756109030000014540239021003682462_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38463",
    clipPath: "url(#SVGID_00000064344775233713215970000007832584080521910406_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_19597_00000176747348248279703450000001506776341257723562_",
    gradientUnits: "userSpaceOnUse",
    x1: -1600.3069,
    y1: 104.4288,
    x2: -1600.1559,
    y2: 104.4288,
    gradientTransform: "matrix(6.6 0 0 6.6 10562.21 -626.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05253"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C52126"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19597",
    x: 122.58,
    y: 59.73,
    fill: "url(#Rectangle_19597_00000176747348248279703450000001506776341257723562_)",
    width: 6.6,
    height: 6.6
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38466"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000020390333767825636340000009158198779951687592_",
    d: "M13.48,117.93c1,1.87,2.1,3.73,3.2,5.48h117 c1.1-1.74,2.2-3.61,3.2-5.48H13.48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052808254078543623950000009941489597287034556_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000020390333767825636340000009158198779951687592_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38465",
    clipPath: "url(#SVGID_00000052808254078543623950000009941489597287034556_)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    enableBackground: "new    ",
    width: 125,
    height: 6,
    id: "Rectangle_19598",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAAGCAYAAADuZZEnAAAACXBIWXMAAAsSAAALEgHS3X78AAAA fElEQVRIie2Ryw7CMAwEx0Fu+/9fmxCpixrRF6Jw4VLqkSx71z55DSDX0Q16jB52NdhGp3lvNvsd 4M/qkNyS+c5b50Xb8f6Td+M8CLgD9aW/877e6PimSJQpwjZPXSqjms5i3TUt8uCpphM9MvgREfoF idAvSIQeBH8P8AChlDgKz2n+JgAAAABJRU5ErkJggg==",
    transform: "matrix(0.8333 0 0 1.0374 23.0981 117.1858)"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38468"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031183112712675642100000002375287863578553249_",
    x: 0.18,
    y: 0.33,
    width: 150,
    height: 150
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024693997835201688430000011841499252145633702_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031183112712675642100000002375287863578553249_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38467",
    clipPath: "url(#SVGID_00000024693997835201688430000011841499252145633702_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64838",
    fill: "#F8B4B6",
    d: "M134.28,74.13c1.16,0,2.1,0.94,2.1,2.1s-0.94,2.1-2.1,2.1s-2.1-0.94-2.1-2.1 S133.12,74.13,134.28,74.13L134.28,74.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64839",
    fill: "#F59394",
    d: "M11.58,57.33c1.44,0,2.6,1.16,2.6,2.6s-1.16,2.6-2.6,2.6s-2.6-1.16-2.6-2.6l0,0 C8.98,58.5,10.15,57.33,11.58,57.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64840",
    fill: "#FFFFFF",
    d: "M142.58,53.33c0.88,0,1.6,0.72,1.6,1.6s-0.72,1.6-1.6,1.6s-1.6-0.72-1.6-1.6 S141.7,53.33,142.58,53.33L142.58,53.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64841",
    fill: "#F6F9FD",
    d: "M63.18,28.33h-1.2v-1.2c0-0.5-0.4-0.9-0.9-0.9s-0.9,0.4-0.9,0.9l0,0v1.2h-1.2 c-0.5,0-0.9,0.4-0.9,0.9s0.4,0.9,0.9,0.9h1.2v1.2c0,0.5,0.4,0.9,0.9,0.9s0.9-0.4,0.9-0.9l0,0v-1.2h1.2c0.5,0,0.9-0.4,0.9-0.9 C64.08,28.74,63.68,28.33,63.18,28.33L63.18,28.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64842",
    fill: "#FFFFFF",
    d: "M99.88,122.33h-47.6c-2.29,0-4.14-1.85-4.15-4.14c0-0.72,0.19-1.43,0.55-2.06 l23.8-41.1c1.12-1.99,3.65-2.69,5.64-1.56c0.65,0.37,1.19,0.91,1.56,1.56l23.8,41.1c1.14,1.99,0.45,4.52-1.54,5.65 C101.31,122.14,100.6,122.33,99.88,122.33"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38470"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000178166268026828951130000000066452699220230842_",
    d: "M74.48,80.73l-19.9,34.4 c-0.52,0.89-0.21,2.03,0.68,2.55c0.28,0.16,0.59,0.25,0.92,0.25h39.8c1.01,0.02,1.85-0.78,1.87-1.8 c0.01-0.35-0.09-0.7-0.27-1l-19.9-34.4c-0.54-0.88-1.69-1.16-2.57-0.63C74.85,80.26,74.64,80.48,74.48,80.73"
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145023995552190805030000007168865512780152708_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000178166268026828951130000000066452699220230842_",
    overflow: "visible"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38469",
    clipPath: "url(#SVGID_00000145023995552190805030000007168865512780152708_)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle_19600_00000017494869320788911090000015014176438387184775_",
    gradientUnits: "userSpaceOnUse",
    x1: -1741.525,
    y1: 18.5034,
    x2: -1741.5029,
    y2: 18.5034,
    gradientTransform: "matrix(44.4 0 0 38.1 77323.9141 -606.0991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05253"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C52126"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19600",
    x: 53.88,
    y: 79.83,
    fill: "url(#Rectangle_19600_00000017494869320788911090000015014176438387184775_)",
    width: 44.4,
    height: 38.1
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_38472"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031922555089980269380000006793445537612129690_",
    x: 0.18,
    y: 0.33,
    width: 150,
    height: 150
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074413281948067303190000015835371881688201613_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031922555089980269380000006793445537612129690_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38471",
    clipPath: "url(#SVGID_00000074413281948067303190000015835371881688201613_)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64844",
    fill: "#FFFFFF",
    d: "M76.08,105.23c-1.1,0-2-0.9-2-2v-10.5c0-1.1,0.9-2,2-2s2,0.9,2,2v10.5 C78.08,104.34,77.18,105.23,76.08,105.23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64845",
    fill: "#FFFFFF",
    d: "M76.08,109.53c1.16,0,2.1,0.94,2.1,2.1s-0.94,2.1-2.1,2.1s-2.1-0.94-2.1-2.1l0,0 C73.98,110.47,74.92,109.53,76.08,109.53"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIWarning);
export default __webpack_public_path__ + "static/media/i-warning.e9815bedf99646c406c26e473ed796ad.svg";
export { ForwardRef as ReactComponent };